module.exports = __webpack_public_path__ + "img/andrew-cross-sale-cta.0d8e4146.png";